import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateDynamicComponent } from './template-component/template-dynamic.component';

const routes: Routes = [
  { path: '', component: TemplateDynamicComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplateDynamicRoutingModule {
}
